var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListCheck = function SvgListCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.261 4.583.383-.458-.92-.769-.385.462-2.58 3.093-1.335-1.335L3 5.153 2.152 6l.424.424 1.8 1.8.465.465.42-.506zm0 6 .383-.458-.92-.769-.382.462L4.76 12.91l-1.335-1.335L3 11.153 2.152 12l.424.424 1.8 1.8.465.465.42-.506zM9.6 5.4v1.2h12V5.4h-12m0 6v1.2h12v-1.2h-12m-1.2 6v1.2h13.2v-1.2H8.4M6 18a1.2 1.2 0 1 0-2.4 0A1.2 1.2 0 0 0 6 18"
  })));
};
export default SvgListCheck;